import { useEffect } from "react"
import useSound from "use-sound"
import engineCountdownSFX from "../lib/audio/3-2-1.mp3"

export const handlePlayEngineCountdownSFX = (
  isSoundOff: any,
  sound: any,
  isError: any,
  isLoading: any,
  start: any,
  disableSounds: any,
  isJackpot: boolean,
) => {
  const [playEngineCountdownSFX, { stop }] = useSound(engineCountdownSFX, {
    volume: parseFloat(sound) / 100 >= 0.5 ? 0.5 : parseFloat(sound) / 100,
  })

  useEffect(() => {
    start === 6 &&
      !isError &&
      !isLoading &&
      !isSoundOff &&
      !disableSounds &&
      !isJackpot &&
      playEngineCountdownSFX()
    if (isSoundOff) {
      stop()
    }
  }, [start, isError, isLoading, isSoundOff, disableSounds, isJackpot])
}
